/* ==========================================================================
   Caffeine Landing Page — Scroll Animations
   Only loaded on page.caffeine-landing template
   ========================================================================== */

(function() {
  /* Title selectors — fade up */
  var TITLE_SELECTORS = [
    '.section-caffeine-strength-statement__title',
    '.section-caffeine-format-selector__eyebrow',
    '.section-caffeine-format-selector__title',
    '.section-caffeine-social-proof__label',
    '.section-caffeine-types__title',
    '.section-caffeine-comparison-table__title',
    '.section-caffeine-product-feature__section-title',
    '.section-caffeine-product-comparison__title',
    '.section-caffeine-format-selector__panel-title'
  ];

  /* Custom animated elements — each with its own class */
  var CUSTOM_ANIMATIONS = [
    { selector: '.section-caffeine-social-proof__review', cssClass: 'caffeine-animate-review' },
    { selector: '.section-caffeine-social-proof__product', cssClass: 'caffeine-animate-product-card' }
  ];

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var cls = entry.target.dataset.animateClass || 'caffeine-animate-title';
        if (entry.isIntersecting) {
          entry.target.classList.add(cls + '--visible');
        } else {
          entry.target.classList.remove(cls + '--visible');
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    /* Titles */
    var titles = document.querySelectorAll(TITLE_SELECTORS.join(','));
    titles.forEach(function(el) {
      el.classList.add('caffeine-animate-title');
      el.dataset.animateClass = 'caffeine-animate-title';
      observer.observe(el);
    });

    /* Custom animations */
    CUSTOM_ANIMATIONS.forEach(function(item) {
      var els = document.querySelectorAll(item.selector);
      els.forEach(function(el) {
        el.classList.add(item.cssClass);
        el.dataset.animateClass = item.cssClass;
        observer.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
